import React from 'react';
import ErrorImage from '../assets/images/no-internet.png';

const ErrorFallback = ({ resetError, error }) => {
  return (
    <div className='z-[30000] flex h-dvh min-h-screen flex-col items-center justify-center bg-background'>
      <img src={ErrorImage} alt='Error' className='h-60 w-60' />
      <h1 className='text-poppins-medium-18 text-text'>Something went wrong</h1>
      <p className='text-poppins-regular-14 text-text'>
        Please reload the app or try again later
      </p>
      <button
        className='mt-4 rounded-full bg-[#181818] px-12 py-2 text-poppins-medium-14 text-white'
        onClick={() => {
          window.location.reload();
          resetError?.();
        }}
      >
        Reload
      </button>
    </div>
  );
};

export default ErrorFallback;
